import { render, staticRenderFns } from "./viewProductDetail.vue?vue&type=template&id=8819ba90&"
import script from "./viewProductDetail.vue?vue&type=script&lang=js&"
export * from "./viewProductDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports